















import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { ToggleItem } from '@/contracts/ui/Toggle'

export default defineComponent({
  name: 'RgsToggle',
  props: {
    layout: {
      type: String,
      default: '',
    },
    options: {
      type: Array as PropType<ToggleItem[]>,
      required: true,
    },
    activeItemId: {
      type: [String, Number],
      required: true,
    },
  },
})
